import defaultThumbnail from '../images/ComponentImages/VideoContentThumbnailTemplate.png';
import lungingThumbnail from '../images/ComponentImages/VideoContentThumbnailTemplate02.png';

class Video {
	constructor({title, id, thumbnail} = {}) {
		if (thumbnail === 'testVar') thumbnail = null;

		this.title = title;
		this.id = id;
		this.thumbnail = thumbnail || lungingThumbnail;
	}
}

class Category {
	constructor({categoryVideos, title} = {}) {
		this.title = title;
		this.categoryVideos = categoryVideos;
	}
}

class VideoContentIndex {
	constructor({categoryVideos} = {}) {
		this.categorysArry = categoryVideos;
	}

	getArray() {
		return this.categorysArry;
	}
}

let videoLibrary = [
	new Video({
		title: 'How to do High Knees | TheBrugMethod',
		thumbnail: 'testVar',
		id: 'b22e1JWQfvU',
		thumbnail: '',
	}) /* 0 */,
	new Video({
		title: 'How to Jog In Place',
		thumbnail: 'testVar',
		id: 'QB_AdSRiKP0',
	}) /* 1 */,
	new Video({
		title: 'How to do PushUps | TheBrugMethod',
		thumbnail: 'testVar',
		id: 'QVIVPN_q5dk',
	}) /* 2 */,
	new Video({
		title: 'Standard Flyes | TheBrugMethod',
		thumbnail: 'testVar',
		id: 'Coawqk-J9bE',
	}) /* 3 */,
	new Video({
		title: 'How to do Incline Flyes | TheBrugMethod',
		thumbnail: 'testVar',
		id: 'rItT1Fe-JL4' /* 4 */,
	}),
	new Video(
		{
			title: 'How to do (BB) Standard Bench Press',
			thumbnail: 'testVar',
			id: 'u-6b0nTTcGg',
		} /* 5 */
	),
	new Video({
		title: 'How to do (BB) Incline Bench Press | TheBrugMethod',
		thumbnail: 'testVar',
		id: 'fBaFwaZtSW0' /* 6 */,
	}),
	new Video({
		title: 'How to do (DD) Bent-Over Rows | TheBrugMethod',
		thumbnail: 'testVar',
		id: 'T0He7AOc9qE' /* 7 */,
	}),
	new Video({
		title: 'How to do Dumbbell Rows | TheBrugMethod',
		thumbnail: 'testVar',
		id: 'Oxqt1CWo42w' /* 8 */,
	}),
	new Video({
		title: 'How to do (BB) Bent-Over Rows | TheBrugMethod',
		thumbnail: 'testVar',
		id: 'Gx7glHYCjP4' /* 9 */,
	}),
	new Video({
		title: 'How to do Standard Deadlifts | TheBrugMethod',
		thumbnail: 'testVar',
		id: 'E4KzinUWqp0' /* 10 */,
	}),
	new Video({
		title: 'How to do Seated Cable Rows | TheBrugMethod',
		thumbnail: 'testVar',
		id: '7gAb2-ImNI8' /* 11 */,
	}),
	new Video({
		title: 'How to do Lateral Raises | TheBrugMethod',
		thumbnail: 'testVar',
		id: 'vHG5FauVZXA' /* 12 */,
	}),
	new Video({
		title: 'How to do Front Raises | TheBrugMethod',
		thumbnail: 'testVar',
		id: '9e6GK16UdMI' /* 13 */,
	}),
	new Video({
		title: 'How to do Seated Lateral Raises | TheBrugMethod',
		thumbnail: 'testVar',
		id: 'bVAhPaQMSDQ' /* 14 */,
	}),
	new Video({
		title: 'How to do Cable Lateral Raises | TheBrugMethod',
		thumbnail: 'testVar',
		id: 'Z1FWaKY9jKo' /* 15 */,
	}),
	new Video({
		title: 'How to do Dumbbell Lateral Raises | TheBrugMethod',
		thumbnail: 'testVar',
		id: 'i8meBks9GMk' /* 16 */,
	}),
	new Video({
		title: 'How to do Close-Grip Bench Press | TheBrugMethod',
		thumbnail: 'testVar',
		id: 'ic5rBFMu1gI' /* 17 */,
	}),
	new Video({
		title: 'How to do Spider Curls | TheBrugMethod',
		thumbnail: 'testVar',
		id: 'x73LA2ggam8' /* 18 */,
	}),
	new Video({
		title: 'How to do Static Holds | TheBrugMethod',
		thumbnail: 'testVar',
		id: 'OSPt7-sh07g' /* 19 */,
	}),
	new Video({
		title: 'How to do Biceps Curls | TheBrugMethod',
		thumbnail: 'testVar',
		id: 'FRlO70b6jcs' /* 20 */,
	}),
	new Video({
		title: 'How to do Tricep KickBacks | TheBrugMethod',
		thumbnail: 'testVar',
		id: 'urbs9lvikfw' /* 21 */,
	}),
	new Video({
		title: 'How to do Hammer Curls | TheBrugMethod',
		thumbnail: 'testVar',
		id: 'GkukfK2Bi3U' /* 22 */,
	}),
	new Video({
		title: 'How to do Skull Crushers | TheBrugMethod',
		thumbnail: 'testVar',
		id: 'Y-5RiL3k8Wk' /* 23 */,
	}),
	new Video({
		title: 'How to do Triceps Cable Pulldowns | TheBrugMethod',
		thumbnail: 'testVar',
		id: 'pwJ_PfBmtP0' /* 24 */,
	}),
	new Video({title: 'How to do Step Ups | TheBrugMethod', thumbnail: 'testVar', id: 'pZSDe_Ha1rA'}) /* 25 */,
	new Video({
		title: 'How to do Split Squats | TheBrugMethod',
		thumbnail: 'testVar',
		id: 'XdsI8npjBzg' /* 26 */,
	}),
	new Video({
		title: 'How to do Jump Squats | TheBrugMethod',
		thumbnail: 'testVar',
		id: 'tXtMsiSLyr0',
	}) /* 27 */,
	new Video({
		title: 'How to do Air Squats | TheBrugMethod',
		thumbnail: 'testVar',
		id: 'P9Uz0UKDjxU',
	}) /* 28 */,
	new Video({
		title: 'How to do Sumo Squats | TheBrugMethod',
		thumbnail: 'testVar',
		id: 'TWzCf23gFkA',
	}) /* 29 */,
];

let organizedVideos = new VideoContentIndex({
	categoryVideos: [
		new Category({
			title: 'Back',
			categoryVideos: [new Video({title: 'dsf', thumbnail: 'testVar', id: 'sdfsa'})],
		}),
	],
});
let oldVideos = [
	{
		category: 'Back',
		videos: [
			videoLibrary[7],
			videoLibrary[8],
			videoLibrary[9],
			videoLibrary[10],
			videoLibrary[11],
			videoLibrary[12],
			videoLibrary[13],
			videoLibrary[14],
			videoLibrary[15],
			videoLibrary[16],
		],
	},
	{
		category: 'Legs',
		videos: [
			videoLibrary[0],
			videoLibrary[1],
			videoLibrary[3],
			videoLibrary[10],
			videoLibrary[25],
			videoLibrary[26],
			videoLibrary[27],
			videoLibrary[28],
		],
	},
	{
		category: 'Arms',
		videos: [
			videoLibrary[18],
			videoLibrary[19],
			videoLibrary[20],
			videoLibrary[21],
			videoLibrary[22],
			videoLibrary[23],
			videoLibrary[24],
		],
	},
	{category: 'Chest', videos: [videoLibrary[3], videoLibrary[4], videoLibrary[5], videoLibrary[6]]},
];

export default oldVideos;
